import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box } from '@chakra-ui/react';
import { Field } from 'formik';
import { useCompanyForm } from '../../hooks/useCompanyForm';
import NameField from '@/components/forms/new/formikFormFields/NameField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';

const InitialDomain = ({ darkMode, errors, touched }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { formData, updateFormData } = useCompanyForm();

    const handleChange = (e) => {
        updateFormData('initialDomain', e.target.value);
    };

    const hasError = !!errors?.initialDomain && touched?.initialDomain;

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={hasError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    Initial Domain
                </FormLabel>
                <Box flex={1} maxWidth="400px">
                    <Field
                        component={NameField}
                        id="initialDomain"
                        name="initialDomain"
                        value={formData?.initialDomain || ''}
                        onChange={handleChange}
                        width="100%"
                        darkMode={darkMode}
                        isInvalid={hasError}
                        isReadOnly={true}
                    />
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="The initial domain configured for this company"
                        ariaLabel="initial-domain-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default InitialDomain;
